<template>
    <div :class="classNames">
        <div :class="classNames+ '_search'">
            <div>
                <el-button type="primary" @click="createSystemFun" >{{isDyFlag ? '新建附赠实物': '新建用户信息获取'}}</el-button>
                <!-- <a style="color:#1989fa;margin-left: 12px;cursor:pointer;font-size:14px;text-decoration: none" href="https://doutuimao.feishu.cn/docs/doccn8rE2uPE6FHsdYcloYSS4hf" target="_blank">什么是用户信息获取？</a> -->
            </div>
        </div>
        <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="accountList.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
                            <el-popover
                                v-if="item.showOverflowTooltip"
                                placement="bottom"
                                title="课程"
                                trigger="click"
                                :popper-class="classNames+'_tip_wrap'"
                                >
                                    <el-scrollbar :class="classNames+'_tip_scroll'">
                                        <ul :class="classNames+'_tip_ul'">
                                            <li v-for="(item, index) in scope.row[item.prop]" :key="index">{{item}}</li>
                                        </ul>
                                    </el-scrollbar>
                                <div slot="reference" class="showOverflowTooltip">{{scope.row[item.prop].join(',')}}</div>
                            </el-popover>
							<span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
                            <span @click="edit(scope.row)" :class="classNames+'_operation_title'">编辑</span>
							<span @click="deltes(scope.row)" :class="classNames+'_operation_title'">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="accountList.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(accountList.total / accountList.limit) > 1"></Pagination>
		</div>
        <el-dialog
            :title="(id? '编辑': '新建') + (isDyFlag ? '附赠实物': '用户信息获取')"
            :visible.sync="dialogVisible"
            width="700px"
            :custom-class="classNames + '_dialog'"
            :key="isResetFlag"
            @close="handleClose">
                <div :class="classNames + '_dialog_content'">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" label-position="top">
                        <el-form-item label="用户信息获取" prop="preserve_method" v-if="!isDyFlag">
                            <el-radio-group v-model="ruleForm.preserve_method">
                                <el-radio :label="item.value" v-for="item in userTypeList" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="ruleForm.preserve_method === 2">
                            <p style="margin-bottom: 8px;line-height: 18px"><span style='color:#F56C6C;margin-right: 4px'>*</span>附赠实物</p>
                            <ul :class="classNames+ '_address_ul'">
                                <li v-for="(item, index) in ruleForm.goods_img" :key="index">
                                    <div class="li-con el-form-item" :class="{'is-error': !item.name}">
                                        <span><span style="color:#F56C6C;margin-right: 4px">*</span>实物名称</span>
                                        <el-input v-model="item.name" placeholder="请输入实物名称" maxlength="8" show-word-limit></el-input>
                                    </div>
                                    <div lass="li-con">
                                        <span><span style="color:#F56C6C;margin-right: 4px">*</span>实物图片</span>
                                        <uploadImg v-model="item.img" :item="{width: 100,height: 100,}" style="display:inline-block" :style="{'border': item.img? '': '1px solid red'}" :is_material="false"></uploadImg>
                                        <span>建议尺寸：100*100</span>
                                    </div>
                                    <div class="opeartion">
                                        <span v-if="ruleForm.goods_img.length - 1 === index" @click="addGoodsimg">添加</span>
                                        <span v-if="ruleForm.goods_img.length> 1" @click="deleteGoodsimg(index)">删除</span>
                                    </div>
                                </li>
                            </ul>
                        </el-form-item>
                        <el-form-item :label="ruleForm.preserve_method === 2 ? '获取地址场景': '获取场景'" prop="is_force" v-if="['/ks/', '/wx/'].includes(staticPath)">
                            <el-radio-group v-model="ruleForm.is_force">
                                <el-radio :label="item.value" v-for="item in is_forceList" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="关联课程" prop="product_ids">
                            <el-button type="primary" @click="addClass">添加课程</el-button>
                            <span style="margin-left: 12px;color: #1989FA;" v-if="ruleForm.product_ids.length">已选课程({{ruleForm.product_ids.length}})</span>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addCancel('ruleForm')">取 消</el-button>
                    <el-button type="primary" @click="addSure('ruleForm')">确 定</el-button>
                </span>
        </el-dialog>
        <gettingList v-model="gettingFlag" @sure="sureClass" :idsList="ruleForm.product_ids" :editId="id"></gettingList>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
import gettingList from './gettingList.vue'
import uploadImg from '@/pages/qualifications/uploadImgItem.vue'
export default {
    data() {
        return {
            classNames: 'gettingUserInformation',
            searchObj: {
                name: '',
                account: '',
                limit: 10,
                page: 1
            },
            headerList: [
                {
					prop: 'id',
					label: 'id',
                    width: 100,
				},
                {
					prop: 'preserve_product_title',
					label: '课程',
                    showOverflowTooltip: true,
                    width: 260
				},
				{
					prop: 'preserve_method_name',
					label: '用户信息获取'
				},
                {
					prop: 'is_force_name',
					label: '获取场景'
				},
				{
					prop: 'created_time',
					label: '添加时间',
                    width: 200
				}
            ],
            accountList: {
                data: [],
                total: 0
            },
            noDataName: 'empty',
            dialogVisible: false,
            ruleForm: {
                preserve_method: this.staticPath === '/' ? 2: '',
                is_force: this.staticPath === '/' ? 2: '',
                product_ids: [],
                goods_img: [
                    {
                        name: '',
                        img: ''
                    }
                ]
            },
            rules: {
                preserve_method: [
                    {
                        required: true, message: '请选择用户信息获取',trigger: "change"
                    }
                ],
                is_force: [
                    {
                        required: true, message: '请选择获取场景',trigger: "change"
                    }
                ],
                product_ids: [
                    { type: 'array', required: true, message: '请至少选择一个课程', trigger: 'change' }
                ]
            },
            userTypeList: [
                {
                    label: '手机号获取',
                    value: 1
                },
                {
                    label: '附赠实物',
                    value: 2
                }
            ],
            is_forceList: [
               {
                    label: '强制(下单前获取)',
                    value: 1
                },
                {
                    label: '非强制(下单后获取)',
                    value: 2
                }
            ],
            gettingFlag: false,
            isResetFlag: false,
            id: ''
        }
    },
    created() {
        this.preserveMethodListFun()
    },
    computed: {
        isDyFlag() {
            return this.staticPath === '/'
        }
    },
    components: {
        Pagination,
        gettingList,
        uploadImg
    },
    methods: {
        ...mapActions('cusomer', ['addPreserveMethod', 'preserveMethodList', 'editPreserveMethod', 'preserveMethodInfo', 'removePreserveMethod']),
        createSystemFun() {
            this.dialogVisible = true
        },
        changeSize(size) {
            this.searchObj.page = size
            // this.getAccountListFun()
        },
        async preserveMethodListFun(flag) {
            if(flag) {
                this.searchObj.page = 1
            }
            let res = await this.preserveMethodList(this.searchObj)
            this.accountList = res
        },
        edit(row) {
            this.dialogVisible = true
            this.id = row.id
            this.detailInfo()
        },
        async detailInfo() {
            let res = await this.preserveMethodInfo({id: this.id})
            for (const key in res) {
                if (this.ruleForm.hasOwnProperty(key)) {
                    if(key === 'goods_img') {
                        this.ruleForm[key] = res[key].length ? res[key]: [
                            {
                                name: '',
                                img: ''
                            }
                        ]
                    } else {
                        this.ruleForm[key] = res[key]
                    }
                }
            }
            console.log(res)
        },
        async deltes(row) {
           this.$confirm('确定要删除吗？', '信息', {
                distinguishCancelAndClose: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: this.classNames + '_common_dialog',
                center: true
            })
            .then(async() => {
                try {
                    await this.removePreserveMethod({id: row.id})
                    this.preserveMethodListFun()
                    this.$message(
                        {
                            type: 'success',
                            message: '删除成功',
                            duration: 3000
                        }
                    )
                } catch (error) {
                    
                }
            })
        },
        search() {
            this.noDataName = 'noData'
            this.getAccountListFun(true)
        },
        addClass() {
            this.gettingFlag = true
        },
        sureClass(list) {
            this.ruleForm.product_ids = list
        },
        addSure(name) {
            this.$refs[name].validate(async (valid) => {
                let flag = true
                if(this.ruleForm.preserve_method == 2) {
                    flag = this.ruleForm.goods_img.every(item => item.name && item.img)
                }
                if(valid && flag) {
                    if(this.id) {
                        await this.editPreserveMethod({id: this.id, ...this.ruleForm})
                        this.preserveMethodListFun()
                    } else {
                        await this.addPreserveMethod(this.ruleForm)
                        this.preserveMethodListFun(true)
                    }
                    this.resetFun(name)
                    this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message: (this.id? '修改' : '新建') + '成功',
                        duration: 3000
                    })
                }
            })
        },
        handleClose() {
            if(this.id) {
                this.resetFun('ruleForm')
            }
            // if(this.id) {
            //     this.resetFun('ruleForm')
            // }
            this.id = ''
        },
        addCancel(name) {
            this.dialogVisible = false
            this.resetFun(name)
        },
        resetFun(name) {
            this.$refs[name].resetFields()
            this.ruleForm = {
                preserve_method: this.isDyFlag ? 2: '',
                is_force: this.staticPath === '/' ? 2: '',
                product_ids: [],
                goods_img: [
                    {
                        name: '',
                        img: ''
                    }
                ]
            }
        },
        addGoodsimg() {
            this.ruleForm.goods_img.push({
                name: '',
                img: ''
            })
        },
        deleteGoodsimg(index) {
            this.ruleForm.goods_img.splice(index, 1)
        }
    }
}
</script>
<style lang="less">
@classNames: gettingUserInformation;
.@{classNames}_operation_title {
    margin-right: 12px;
    color: #1989FA;
    font-size: 14px;
    cursor: pointer;
}
.@{classNames}_dialog {
    .el-dialog__header {
        padding: 12px 24px;
    }
    .el-dialog__body {
        padding: 12px 24px;
        .el-form-item__label {
            line-height: 18px;
        }
    }
    .@{classNames}_list {
        display: flex;
        justify-content: space-between;
        .gettingList {
            width: 46%;
        }
    }
}
.@{classNames}_tip_wrap {
    .@{classNames}_tip_scroll {
        max-height: 300px;
        display: flex;
        flex-direction: column;
    }
    .@{classNames}_tip_ul {
        li {
            list-style: none;
            padding: 6px 0;
        }
    }
}
</style>
<style lang="less" scoped>
    @classNames: gettingUserInformation;
    .@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
        .showOverflowTooltip {
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis
        }
        .el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
    .@{classNames}_address_ul {
        li {
            list-style: none;
            display: flex;
            flex-direction: column;
            width: 500px;
            box-shadow: 0 0 6px rgba(0,0,0,0.5);
            padding: 8px;
            box-sizing: border-box;
            border-radius: 6px;
            &:not(:first-child) {
                margin-top: 12px;
            }
            >div{
                display: flex;
                span {
                    line-height: 30px;
                    white-space: nowrap;
                    margin-right: 12px;
                }
                &:not(:last-child) {
                    margin-bottom: 12px;
                }
            }
            .opeartion {
                display: flex;
                justify-content: flex-end;
                span {
                    color: #409EFF;
                    cursor: pointer;
                }
            }
        }
    }
</style>
